import './scss/index.scss';
import { dcFactory } from 'dc';
import GenericSectionComponent from './js/generic-section.component';

dcFactory.register(GenericSectionComponent);
